import React from 'react'
import { useSelector } from 'react-redux'
import { userPointsStyles as styles } from './userPoints.tailwind';

const UserPoints = () => {
  const { userPointsAndRewards } = useSelector((state) => state.reward);
  
  return (
    <div className={styles.outerContainer}>
      {/* User Points */}
      <div className={styles.pointsContainer}> 
        <p className={styles.pointsText}>{userPointsAndRewards?.userTotalEarnedPoints}</p>
        <p className={styles.pointsHeading}>Lifetime Points</p>
      </div>

      <div className={styles.divider} />

      <div className={styles.pointsContainer}>
        <p className={styles.pointsText}>{userPointsAndRewards?.userTotalAvailablePoints}</p>
        <p className={styles.pointsHeading}>Available Points</p>
      </div>
    </div>
  )
}

export default UserPoints